<template>
  <div class="row form-group">
    <div class="col-md-4 text-left">
      <span>{{label}} <span v-if="optional" class="small text-muted">(optional)</span></span>
    </div>
    <div class="col-md-8">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabeledFormControl',
  props: {
    label: String,
    optional: {
      type: Boolean,
      default: false
    }
  }
}
</script>
